module.exports = __webpack_public_path__ + "img/Link.f6f2f1f5.svg";